/**
 * Csv Schema of ResponsavelWebhook
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelWebhook} from '@/model/resource/ResponsavelWebhook'

/* TODO: review generated schema */
export class CsvResponsavelWebhookSchema extends Schema {
  readonly name = 'CsvResponsavelWebhook'

  readonly fieldSet: FieldSet<ResponsavelWebhook> = {
    idWebhookPk: schema => schema.model.idWebhookPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    typeWebhook: schema => schema.model.typeWebhook?.$id ?? null,
    url: schema => schema.model.url,
  }
}
